import { app } from '../../app.module'
/**
 * 投稿一覧に表示するタグ一覧のディレクティブが呼び出された際に使用するサービス
 * @return {Object} オブジェクト
 */
function accountTableTagListInit() {
  /**
   * parseTags タグの一覧が文字列になっているので、オブジェクトに変換する
   * @param tagsIdsStr 文字列になっているタグの一覧
   * @param tagsNamesStr 文字列になっているタグの一覧
   * @return tags オブジェクトの配列に整形したタグ一覧
   */
  function parseTags(tagsIdsStr: string, tagsNamesStr: string) {
    const tags = []
    // タグごとに区切り文字','で区切られているので、配列に戻す
    const TagIdsStrsArray: string[] = tagsIdsStr.split(',')
    const TagNamesStrsArray: string[] = tagsNamesStr.split(',')

    // タグごとに、オブジェクトに整形して、配列にプッシュする
    TagIdsStrsArray.forEach((elem: string, index: number) => {
      const tagObj: {
        tagId: string
        tagName: string
      } = {
        tagId: elem,
        tagName: TagNamesStrsArray[index],
      }

      if (tagObj.tagId !== null) {
        tags.push(tagObj)
      }
    })
    return tags
  }

  /**
   * getTagsFromArray タグ一覧の配列からタグ一覧の文字列にする
   * @param tagsArray 配列になっているタグの一覧
   * @return object 文字列になっているタグの一覧
   */
  function getTagsFromArray(tagsArray) {
    let tags: string = null
    let tagIds: string = null

    // タグがある場合
    if (tagsArray.length > 0) {
      tagsArray.forEach((tag, index) => {
        if (index === 0) {
          tags = tag.tagName
          tagIds = String(tag.tagId)
        } else {
          tags = tags + ',' + tag.tagName
          tagIds = tagIds + ',' + String(tag.tagId)
        }
      })
    }

    return {
      tags: tags,
      tagIds: tagIds,
    }
  }

  return {
    parseTags: parseTags,
    getTagsFromArray: getTagsFromArray,
  }
}

function accountTableTagListService(accountTableTagListInit) {
  return {
    Init: accountTableTagListInit,
  }
}

app
  .factory('accountTableTagListInit', accountTableTagListInit)
  .factory('accountTableTagListService', accountTableTagListService)
